import { PatientDataAccessMode } from '~libs.shared.prescription';

export enum HistoryDownloadStepName {
   ACCESS_VERIFICATION,
   ACCESS_REQUEST,
   ACCESS_CODE,
   NO_IKP_PLACEHOLDER,
   PRESCRIPTIONS_HISTORY,
   P1_COMMUNICATION_FAULT,
}

export type HistoryDownloadAccessCodeStep = {
   name: HistoryDownloadStepName.ACCESS_CODE;
   state: {
      applicationId: string;
   };
};
export type HistoryDownloadAccessVerificationStep = {
   name: HistoryDownloadStepName.ACCESS_VERIFICATION;
   state?: never;
};
export type HistoryDownloadAccessRequestStep = {
   name: HistoryDownloadStepName.ACCESS_REQUEST;
   state: {
      errorMessage?: string;
   };
};
export type HistoryDownloadNoIkpPlaceholderStep = {
   name: HistoryDownloadStepName.NO_IKP_PLACEHOLDER;
   state?: never;
};
export type HistoryDownloadPrescriptionsHistoryStep = {
   name: HistoryDownloadStepName.PRESCRIPTIONS_HISTORY;
   state: {
      accessMode: PatientDataAccessMode | undefined;
   };
};
export type HistoryDownloadAccessP1CommunicationFaultStep = {
   name: HistoryDownloadStepName.P1_COMMUNICATION_FAULT;
   state: {
      faultDescription: string | undefined;
   };
};
export type HistoryDownloadStep =
   | HistoryDownloadAccessCodeStep
   | HistoryDownloadAccessVerificationStep
   | HistoryDownloadAccessRequestStep
   | HistoryDownloadNoIkpPlaceholderStep
   | HistoryDownloadPrescriptionsHistoryStep
   | HistoryDownloadAccessP1CommunicationFaultStep;
